import React from "react";
import { convertMinutesToHHMM } from "../../../../../Reports/NextStopCompliance/NextStopComplianceUtills";
import format from "date-fns/format";
import { getMinutesfromTimeString } from "../../../../../../dataGrid/gridUtilities";
import {
  renderTimeWithErrorIcon,
  getStopArrivalTimeForDriverGrid,
  hasStopDelayed,
  getArrivedAtOrEnrouteStop,
} from "../../../utils";
import { getFilteredLunchBreakDelaysByDriverRoute } from "../../../../utils/utils";
import StyledToolTip from "../../../../../../common/StyledToolTip";
import { DRIVER_EVENTS } from "../../../constants";
import appConstants from "../../../../../../../appConstants";
import { getDriverStatus } from "../../../utils/DriverStatus";

const ETATimeRenderer = (props) => {
  const getExpectedLunchTimeEnd = (props) => {
    const lunchBreakStops = getFilteredLunchBreakDelaysByDriverRoute(
      props.data.delays,
      [props.data.routeId]
    );
    const currentLunchBreakStop = lunchBreakStops.filter(
      (lunchBreak) => !lunchBreak.endTime
    )[0];
    if (currentLunchBreakStop) {
      const lunchStartTime = currentLunchBreakStop.startTime;
      const minFromTimeString = getMinutesfromTimeString(lunchStartTime);
      return convertMinutesToHHMM(
        minFromTimeString + props.data.driverLunchDurationInMinutes
      );
    }
    return null;
  };

  const { driverStatus } = getDriverStatus(props, false);
  if (DRIVER_EVENTS.ReturnToTerminal === driverStatus) {
    return renderTimeWithErrorIcon(
      format(props.data.arriveAtTerminalTime, appConstants.DATETYPES.TIME.format),
      false
    );
  } else if (DRIVER_EVENTS.LunchBreak === driverStatus) {
    return getExpectedLunchTimeEnd(props);
  } else {
    const selectedStop = getArrivedAtOrEnrouteStop(props);
    if (selectedStop) {
      const arrivalTime = getStopArrivalTimeForDriverGrid(driverStatus, selectedStop);
      if (!arrivalTime) {
        return null;
      }
      const hasDelayed = hasStopDelayed(selectedStop);
      return (
        <StyledToolTip
          title={hasDelayed ? "Arriving Late" : arrivalTime}
        >
          {renderTimeWithErrorIcon(arrivalTime, hasDelayed)}
        </StyledToolTip>
      );
    }
  }
  return null;
};

export default ETATimeRenderer;
